import React from 'react';
import LanguageIcon from '@/components/icons/LanguageIcon';

const LanguageSwitch: React.FC = () => (
  <span className="flex items-center gap-1 p-2 text-sm text-gray-500 dark:text-gray-400" title="界面语言：简体中文" aria-label="界面语言：简体中文">
    <LanguageIcon className="h-5 w-5" />
    <span>简体中文</span>
  </span>
);

export default LanguageSwitch;
